import { useAuth } from "@/auth/AuthProvider"
import { Button } from "@/components/ui"

/**
 * Login-Seite. Im Logto-Modus leitet der AuthProvider bereits automatisch
 * zum OIDC-Login weiter (LogtoGate) — diese Seite ist der Fallback nach
 * Abmeldung bzw. für den manuellen "Erneut anmelden"-Klick.
 */
export function LoginPage() {
  const { signIn, isAuthenticated } = useAuth()
  return (
    <main className="flex min-h-screen items-center justify-center bg-slate-100">
      <div className="w-full max-w-sm rounded-xl bg-white p-8 shadow">
        <h1 className="mb-2 text-xl font-semibold text-slate-900">RMNC Stammdaten</h1>
        <p className="mb-6 text-sm text-slate-600">Anmeldung über Logto (user.rmnc.app).</p>
        {isAuthenticated ? (
          <p className="text-sm text-green-700">Angemeldet.</p>
        ) : (
          <Button onClick={signIn} className="w-full justify-center">
            Mit Logto anmelden
          </Button>
        )}
      </div>
    </main>
  )
}
